import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'login' },
      component: () => import(/* webpackChunkName: "commons" */ './layouts/Plain'),
      children: [
        { path: 'entrata', name: 'login', component: () => import(/* webpackChunkName: "commons" */ './views/Login') }
      ]
    },

    {
      path: '/app',
      component: () => import(/* webpackChunkName: "commons" */ './layouts/Main'),
      children: [
        { path: '', name: 'landing', meta: { auth: true, intermediario: true }, component: () => import(/* webpackChunkName: "commons" */ './views/LandingSpidPage') },
        { path: 'preLanding', name: 'preLanding', meta: { auth: true, intermediario: true }, component: () => import(/* webpackChunkName: "commons" */ './views/PreLandingSpidPage') },
        { path: 'home', name: 'home', meta: { auth: true }, component: () => import(/* webpackChunkName: "commons" */ './views/Home') },
        { path: 'aiuto', name: 'aiuto', meta: { auth: true }, component: () => import(/* webpackChunkName: "commons" */ './views/Aiuto') },
        { path: 'changePassword', name: 'changePassword', meta: { auth: true }, component: () => import(/* webpackChunkName: "commons" */ './views/ChangePassword') },
        { path: 'recuperaPassword', name: 'recuperaPassword', meta: { auth: false }, component: () => import(/* webpackChunkName: "commons" */ './views/RecuperaPassword') },
        { path: 'registraUtente', name: 'registraUtente', meta: { auth: false }, component: () => import(/* webpackChunkName: "commons" */ './views/RegistraUtente') },
        { path: 'cambiaMobileUtente', name: 'cambiaMobileUtente', meta: { auth: false }, component: () => import(/* webpackChunkName: "commons" */ './views/CambiaMobileUtente') },
        { path: 'dichiarazioni', name: 'dichiarazioni', meta: { auth: true, spid: true }, component: () => import(/* webpackChunkName: "dichiarazioni" */ './views/DichiarazioneList') },
        { path: 'messages', name: 'messages', meta: { auth: true }, component: () => import(/* webpackChunkName: "messages" */ './views/MessagesList') },
        { path: 'message/:id', name: 'message', meta: { auth: true }, component: () => import(/* webpackChunkName: "message" */ './views/MessageForm') },
        { path: 'bollette', name: 'bollette', meta: { auth: true }, component: () => import(/* webpackChunkName: "bollette" */ './views/BolletteList') },
        { path: 'comunicazioni', name: 'comunicazioni', meta: { auth: true }, component: () => import(/* webpackChunkName: "comunicazioni" */ './views/ComunicazioniList') },
        { path: 'estratticonto', name: 'estratticonto', meta: { auth: true }, component: () => import(/* webpackChunkName: "estratticonto" */ './views/EstratticontoList') },
        { path: 'estrattoconto', name: 'estrattoconto', meta: { auth: true }, component: () => import(/* webpackChunkName: "estrattoconto" */ './views/EstrattocontoDetails') },
        { path: 'normative', name: 'normative', meta: { auth: true }, component: () => import(/* webpackChunkName: "incassi" */ './views/NormativeList') },
        { path: 'istanze', name: 'istanze', meta: { auth: true, spid: true }, component: () => import(/* webpackChunkName: "istanze" */ './views/IstanzeList') },
        // { path: 'istanze', name: 'istanze', meta: { auth: true }, component: () => import(/* webpackChunkName: "istanze" */ './views/IstanzeList') },
        { path: 'istanze/:id', name: 'istanza', meta: { auth: true, spid: true }, component: () => import(/* webpackChunkName: "istanze" */ './views/IstanzaForm') },
        { path: 'dichiarazioni/:id', name: 'dichiarazione', meta: { auth: true, spid: true }, component: () => import(/* webpackChunkName: "dichiarazioni" */ './views/DichiarazioneForm') },
        { path: 'redditiPatrimonio/:id', name: 'redditiPatrimonio', meta: { auth: true, spid: true }, component: () => import(/* webpackChunkName: "redditiPatrimonio" */ './views/RedditiPatrimonioForm') },
        { path: 'incarichi', name: 'incarichi', meta: { auth: true, spid: true }, component: () => import(/* webpackChunkName: "incarichi" */ './views/IncarichiList') },
        { path: 'incarico', name: 'incarico', meta: { auth: true, spid: true }, component: () => import(/* webpackChunkName: "incarichi" */ './views/IncaricoForm') },
        { path: 'incaricoIncaricato', name: 'incaricoInc', meta: { auth: true, spid: true, intermediario: true }, component: () => import(/* webpackChunkName: "incarichi" */ './views/IncaricoFormIncaricato') }
      ]
    },

    {
      path: '/admin',
      redirect: { name: 'loginAdmin' },
      component: () => import(/* webpackChunkName: "commons" */ './layouts/Admin'),
      children: [
        { path: '', name: 'loginAdmin', component: () => import(/* webpackChunkName: "commons" */ './views/admin/LoginAdmin') },
        { path: '/pannelloAdmin', name: 'admin-panel', meta: { auth: true, roles: ['admin'] }, component: () => import(/* webpackChunkName: "commons" */ './views/admin/PannelloControllo') },
        { path: '/notifiche', name: 'admin-notifiche', meta: { auth: true, roles: ['admin'] }, component: () => import(/* webpackChunkName: "commons" */ './views/admin/Notifiche') },
        { path: '/notifiche/:id', name: 'admin-notifica', meta: { auth: true, roles: ['admin'] }, component: () => import(/* webpackChunkName: "commons" */ './views/admin/Notifica') }
      ]
    },

    {
      path: '/',
      component: () => import(/* webpackChunkName: "commons" */ './layouts/Error'),
      children: [
        { path: 'unauthorized', name: 'unauthorized', component: () => import(/* webpackChunkName: "commons" */ './views/Unauthorized') },
        { path: 'cancelled', name: 'cancelled', component: () => import(/* webpackChunkName: "commons" */ './views/CancelOP') },
        { path: '*', name: 'not-found', component: () => import(/* webpackChunkName: "commons" */ './views/NotFound') }
      ]
    }

  ]
})

router.beforeEach(async (to, from, next) => {
  // console.log('!to.meta || !to.meta.auth', to, from, next)
  // let idEnv = process.env.NODE_ENV.trim()
  let idEnv = store.state.auth.user.mode ? store.state.auth.user.mode : process.env.NODE_ENV.trim()
  // let idEnv = 'test'

  // console.log('idEnv', idEnv, store.state.auth.user.mode)
  if (!to.meta || !to.meta.auth) {
    // console.log('COND: !to.meta || !to.meta.auth', to.meta)
    next(true)
  } else {
    // console.log('BEFORE store.getters.isAuthenticated', store.state.auth.user)
    if (!store.getters.isAuthenticated) await store.dispatch('info')

    // console.log('BEFORE: !store.getters.isAuthenticated', store.getters.isAuthenticated, store.state.auth.user, to.name)

    if (!store.getters.isAuthenticated) {
      // console.log('COND: !store.getters.isAuthenticated', store.getters.isAuthenticated)
      next({ name: 'login' })
      // Nel caso di altre route soggette a SPID verificare se necessario validita === 'V', in caso contrario fare controllo su specifica route.
    } else if (to.meta.intermediario && store.getters.isIntermediario) {
      // Accede solo se utente corrente è un intermediario e non sta utilizzando la delega
      next()
    } else if (!store.getters.isIntermediario &&
      // idEnv === 'production' &&
      // solo per test
      // ((to.meta.spid && (store.state.auth.user.autenticazione === 'spid' || store.state.auth.user.userInc.autenticazione === 'spid')) || !to.meta.spid)) {
      // produzione
      // ((to.meta.spid && (store.state.auth.user.autenticazione === 'spid' || store.state.auth.user.userInc.autenticazione === 'spid') && store.state.auth.user.validita === 'V') || !to.meta.spid)) {
      ((to.meta.spid && (store.state.auth.user.autenticazione === store.state.auth.autentication.strong || store.state.auth.user.userInc.autenticazione === store.state.auth.autentication.strong) && store.state.auth.user.validita === 'V') || !to.meta.spid)) {
      // console.log('Verifica pagina', to.name, store.state.auth.user, to)
      if (to.name === 'istanze' || to.name === 'istanza') {
        next()
      } else {
        next()
      }
    } else if ((idEnv === 'test' || idEnv === 'development' || idEnv === 'dev')) {
      // GM: SOLO TEST abilita accesso a parte sottoposta a SPID solo  per test

      // Devo vedere qui come trasformare l'accesso dell'intermediario a livello di "landing" in accesso incaricato come titolare.
      // ========>>

      if (store.getters.isIntermediario && to.meta.intermediario) {
        // console.log('Intermediario che opera come intermediario su pagine intermediario:', store.getters.isIntermediario, to.meta.intermediario)
        // if (to.name !== 'landing' && to.name !== 'login' && to.name !== 'incaricoInc') next({ name: 'unauthorized' })
        // Forzo la pagina a "landing"
        // next({ name: 'landing' })
        next()
      } else if (store.getters.isIntermediario && !to.meta.intermediario) {
        router.push({ name: 'unauthorized' })
      } else next()
    } else router.push({ name: 'unauthorized' })
  }
})

export default router
